import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class AutoDialerDto extends InspectionCase {
  item_4_1?: InspectionCase;
  item_4_2?: InspectionCase;
  item_4_3?: InspectionCase;
  item_4_4?: InspectionValueCase;
  item_4_5?: InspectionCase;
  item_4_6?: InspectionValueCase;
  item_4_7?: InspectionValueCase;
  item_4_8?: InspectionCase;
}

export class AutoDialer extends AutoDialerDto {
  constructor(data: AutoDialerDto = { title: 'חייגן אוטומטי' }) {
    super(data);
    this.item_4_1 = new InspectionCase({
      ...data.item_4_1,
      title: `קו הטלפון של החייגן מוגן לכל אורכו בצינור עד למרכזייה`
    });
    this.item_4_2 = new InspectionCase({
      ...data.item_4_2,
      title: `החייגן מותקן בסמוך לרכזת במרחק שאינו עולה על 2 מ'`
    });
    this.item_4_3 = new InspectionCase({
      ...data.item_4_3,
      title: `קו בזק  מחובר  לפני המרכזייה שבמבנה ומפנה את קו הטלפון בזמן אזעקת אש`
    });
    this.item_4_4 = new InspectionValueCase({
      ...data.item_4_4,
      title: `ספק הטלפון :בזק/HOT. HOT   מצריך גיבוי חשמלי של 24 25 שעות`
    });
    this.item_4_5 = new InspectionCase({
      ...data.item_4_5,
      title: `קו טלפון הדורש הזנה מרשת החשמל מצויד בגיבוי בהתאם לסעיף 9`
    });
    this.item_4_6 = new InspectionValueCase({
      ...data.item_4_6,
      title: `גודל המצברים`
    });
    this.item_4_7 = new InspectionValueCase({
      ...data.item_4_7,
      title: `זרם נמדד`
    });
    this.item_4_8 = new InspectionCase({
      ...data.item_4_8,
      title: `תקלה בקו טלפון או הזנת מתח לחייגן מדווחת ברכזת`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_4_1.isApplicable || this.item_4_1.isPassed) &&
        (!this.item_4_2.isApplicable || this.item_4_2.isPassed) &&
        (!this.item_4_3.isApplicable || this.item_4_3.isPassed) &&
        (!this.item_4_4.isApplicable || this.item_4_4.isPassed) &&
        (!this.item_4_5.isApplicable || this.item_4_5.isPassed) &&
        (!this.item_4_6.isApplicable || this.item_4_6.isPassed) &&
        (!this.item_4_7.isApplicable || this.item_4_7.isPassed) &&
        (!this.item_4_8.isApplicable || this.item_4_8.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_4_1.getNotes(),
      ...this.item_4_2.getNotes(),
      ...this.item_4_3.getNotes(),
      ...this.item_4_4.getNotes(),
      ...this.item_4_5.getNotes(),
      ...this.item_4_6.getNotes(),
      ...this.item_4_7.getNotes(),
      ...this.item_4_8.getNotes()
    ];
  }
}
